import type { FaireProductEntity } from "../../entity_types/product";

export const p_ychmzg6522: FaireProductEntity = {
  token: "p_ychmzg6522",
  type: "product",
  name: "After Hours Decaf",
  brandToken: "b_6su5v1sirt",
  brandName: "Highwire Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/0c37133f6b054cededd5a13ee6f52be6adb3aaf41f29e5435bf3fbd2a5346ae4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/068df5b7c42e0b3dd8f52d52bbee9609e12025c258226d52b035d2bac4a671bb.png",
    "https://cdn.faire.com/fastly/6ff3645a4dbff46423c78803b42f1d9b258519721dedd5c12b8ff809130273f8.png",
    "https://cdn.faire.com/fastly/898bc43ce3c170e6cbca6c62e56692a57250a2462f497665eed0c5fe7853e407.png",
    "https://cdn.faire.com/fastly/bfd4f3ff54a25b42dd2cea8742313c2d6e6c44ff43e4e8cb92e5d9ffadee5efd.png"
  ],
  priceDollars: 12.95,
  description: "Sweet—Syrupy—Dry Cocoa\n\nBackstory:\nAfter Hours was named simply for the fact that sometimes you want a little more coffee late in the day, but maybe don't need the caffeine. Decaf can be delicious. This is our proof.\n\nOrigins:\nWe source tasty decaf coffees and tend to prefer those that are decaffeinated through either the water-processed method, or the sugar-cane process. We feel these are both better for you and the environment.\n\nPairings:\nPairs well with mellow vibes such as Miles Davis' \"Kind of Blue”, Spain's \"The Blue Moods of Spain\", Violent Femmes \"Good Feeling\" or its namesake “After Hours\" by the Velvet Underground.\n\nBrew:\nBrew Use a scale and grind fresh. Use 16 grams of water at 200°F for each gram of coffee.",
  tags: [],
  msrpDollars: 18.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:18.565Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
